



































































































































































import Vue from 'vue';
import Api from '../../base/api.typings';
import Component from 'vue-class-component';
import produtoService from './produto-service';
import routerService from '../../base/router-service';
import areaService from '../area-atual/area-service';

interface ProdutoDto extends Api.App.Server.Produto.Listar.ProdutoDto {}

@Component
export default class ProdutoListar extends Vue {
    itens: ProdutoDto[] = null;
    produtoIdSelecionados: [] = null;
    areaAtual: string = null;

    get carregando() {
        return !this.itens;
    }
    get checkbox() {
        return !this.produtoIdSelecionados;
    }

    beforeRouteUpdate() {
        this.listar();
    }

    async created() {
        this.areaAtual = await areaService.obterAreaPadrao();
        if (this.areaAtual == 'admin') {
            this.listar();
        }
    }

    private async listar() {
        let resultado = await produtoService.listar({});

        this.itens = resultado.itens;
    }

    async editarProduto(produtoId: number) {
        if (this.areaAtual == 'admin') {
            await routerService.goTo('produto-editar', { produtoId });
        }
    }

    async visualizarProduto(produtoId: number) {
        if (this.areaAtual == 'admin') {
            await routerService.goTo('produto-visualizar', { produtoId });
        }
    }

    async ocultarVisualizarProduto(item: ProdutoDto, acao: boolean) {
        if (this.areaAtual == 'admin') {
            let titulo;
            let mensagem;
            let texto;

            if (acao) {
                titulo = 'Vizualizar';
                mensagem = 'Deseja realmente visualizar ?';
                texto = 'Produto visível';
            } else {
                titulo = 'Ocultar';
                mensagem = 'Deseja realmente ocultar ?';
                texto = 'Ocultado com sucesso';
            }

            let ocultar = await this.$confirm.open({
                title: titulo,
                message: mensagem,
            });
            if (ocultar) {
                await produtoService.ocultarVisualizar({
                    produtoIds: [item.id],
                    acao: acao,
                });
                this.$snackbars.open({
                    text: texto,
                    color: 'success',
                });
                await this.listar();
            }
        }
    }

    async ocultarVisualizarProdutosSelecionados(acao: boolean) {
        if (this.areaAtual == 'admin') {
            let titulo;
            let mensagem;
            let texto;

            if (acao) {
                titulo = 'Vizualizar';
                mensagem = 'Deseja realmente visualizar ?';
                texto = 'Produto visível';
            } else {
                titulo = 'Ocultar';
                mensagem = 'Deseja realmente ocultar ?';
                texto = 'Ocultado com sucesso';
            }

            let ocultar = await this.$confirm.open({
                title: titulo,
                message: mensagem,
            });
            if (ocultar) {
                await produtoService.ocultarVisualizar({
                    produtoIds: this.produtoIdSelecionados,
                    acao: acao,
                });
                this.$snackbars.open({
                    text: texto,
                    color: 'success',
                });
                await this.listar();
                this.produtoIdSelecionados = [];
            }
        }
    }

    async excluirProduto(item: ProdutoDto) {
        if (this.areaAtual == 'admin') {
            this.$action.processAction({
                action: async () => {
                    let excluir = await this.$confirm.open({
                        title: 'Excluir',
                        message: 'Deseja realmente excluir ?',
                    });
                    if (excluir) {
                        await produtoService.excluir({
                            produtoIds: [item.id],
                        });
                        this.$snackbars.open({
                            text: 'Excluído com sucesso',
                            color: 'success',
                        });
                        await this.listar();
                    }
                },
            });
        }
    }

    async excluirProdutosSelecionados() {
        if (this.areaAtual == 'admin') {
            this.$action.processAction({
                action: async () => {
                    let excluir = await this.$confirm.open({
                        title: 'Excluir',
                        message: 'Deseja realmente excluir ?',
                    });
                    if (excluir) {
                        await produtoService.excluir({
                            produtoIds: this.produtoIdSelecionados,
                        });
                        this.$snackbars.open({
                            text: 'Excluídos com sucesso',
                            color: 'success',
                        });
                        await this.listar();
                        this.produtoIdSelecionados = [];
                    }
                },
            });
        }
    }
}
